import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import { urlLang, ensureLanguage } from './i18n';
import { LANGS, localizedPath, splitLangPath, basenameFor, withoutLangParam } from './config/langs';
import App from './App.jsx'

/**
 * Legacy ?lang= links (/project/524?lang=en) predate the language prefixes.
 * In production vercel.json answers them with a 301, but that rule cannot
 * strip ?lang=ar without looping, and the dev server has no redirects at all,
 * so the browser finishes the job: navigate to the prefixed URL, or simply
 * drop the parameter when the URL already matches.
 */
function resolveLegacyLangParam() {
    const params = new URLSearchParams(window.location.search);
    const wanted = (params.get('lang') || '').split('-')[0].toLowerCase();
    if (!wanted) return false;

    const { path } = splitLangPath(window.location.pathname);
    const target = (LANGS.includes(wanted) ? localizedPath(path, wanted) : window.location.pathname)
        + withoutLangParam(window.location.search) + window.location.hash;

    if (LANGS.includes(wanted) && wanted !== urlLang) {
        window.location.replace(target);
        return true;
    }
    window.history.replaceState(null, '', target);
    return false;
}

async function start() {
    if (resolveLegacyLangParam()) return;

    // Russian, Chinese and Urdu strings are lazy chunks. Waiting for them
    // keeps the prerendered page on screen instead of flashing English.
    await ensureLanguage(urlLang);

    createRoot(document.getElementById('root')).render(
        <StrictMode>
            <BrowserRouter basename={basenameFor(urlLang)}>
                <App />
            </BrowserRouter>
        </StrictMode>,
    );
}

start();
